import { Component, Input } from '@angular/core';
import { PageBuilderHSeparatorModel, PAGE_BUILDER_SEPARATOR_STYLE } from './page-builder-hseparator.model';

@Component({
    selector: 'abw-page-builder-hseparator',
    templateUrl: './page-builder-hseparator.component.html',
    styleUrls: ['./page-builder-hseparator.component.scss']
})
export class PageBuilderHSeparatorComponent {
    @Input() model: PageBuilderHSeparatorModel;
    @Input() value: string;
    PAGE_BUILDER_SEPARATOR_STYLE = PAGE_BUILDER_SEPARATOR_STYLE;
}